"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const client_1 = require("@apollo/client");
//
// assets
//
const blankBackground_webp_1 = __importDefault(require("assets/images/blankBackground.webp"));
const HeroImage_1 = __importDefault(require("components/onboarding/HeroImage"));
const queryDefinitions_1 = require("queryDefinitions");
const passwordResetCopy_1 = require("copy/passwordResetCopy");
const cache_1 = require("cache");
const tokenHeader_1 = require("tokenHeader");
const loginCopy_1 = require("copy/loginCopy");
//
// components
//
const OnboardingForm_1 = __importDefault(require("components/onboarding/OnboardingForm"));
const PasswordInput_1 = __importDefault(require("components/general/inputs/PasswordInput"));
const FormValidation_1 = require("components/general/utility/FormValidation");
const components_1 = require("@/common/components");
//
// styles
//
const StyledImageBackground_1 = require("components/onboarding/styles/StyledImageBackground");
const LocalAccount_1 = __importDefault(require("LocalAccount"));
const AccountContext_1 = require("contexts/AccountContext");
const linkProps = {
    preface: loginCopy_1.loginCopy.linkPreface,
    href: loginCopy_1.loginCopy.linkHref,
    prompt: loginCopy_1.loginCopy.linkPrompt
};
const PasswordReset = () => {
    const { setAccount } = (0, AccountContext_1.useAccount)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { code } = (0, react_router_dom_1.useParams)();
    const [password, setPassword] = (0, react_1.useState)('');
    const [passwordConfirmation, setPasswordConfirmation] = (0, react_1.useState)('');
    const [serviceAgreement, setServiceAgreement] = (0, react_1.useState)(false);
    const [passwordError, setpasswordError] = (0, react_1.useState)('');
    const [passwordConfirmationError, setPasswordConfirmationError] = (0, react_1.useState)('');
    const [agreementError, setAgreementError] = (0, react_1.useState)('');
    const [resetPassword, { data, loading, error }] = (0, client_1.useMutation)(queryDefinitions_1.PERFORM_PASSWORD_RESET);
    const [authedLazyQuery, 
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    { data: accountData, loading: accountLoading, error: accountError }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_ACCOUNTS);
    const [login, { loading: loginLoading, error: loginError }] = (0, client_1.useMutation)(queryDefinitions_1.LOGIN_USER, {
        onCompleted({ signIn }) {
            if (signIn) {
                localStorage.setItem('token', signIn.session.token);
                (0, cache_1.isLoggedInVar)(true);
                // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
                authedLazyQuery();
            }
        }
    });
    function toggleServiceCheckbox() {
        setAgreementError('');
        setServiceAgreement((prev) => !prev);
    }
    function handleBlur(event) {
        const inputError = (0, FormValidation_1.validateInput)(event.target.id, event.target.value);
        if (inputError) {
            if (event.target.id === 'password') {
                setpasswordError(inputError);
            }
            if (event.target.id === 'passwordConfirmation') {
                setPasswordConfirmationError(inputError);
            }
        }
        else {
            if (event.target.id === 'password') {
                setpasswordError('');
            }
            if (event.target.id === 'passwordConfirmation') {
                setPasswordConfirmationError('');
            }
        }
    }
    function handleInputChange(event) {
        if (event.target.id === 'password') {
            setPassword(event.target.value);
        }
        if (event.target.id === 'passwordConfirmation') {
            setPasswordConfirmation(event.target.value);
        }
    }
    function handleReset(e) {
        e.preventDefault();
        if (!serviceAgreement) {
            setAgreementError('Please review and agree in order to proceed.');
            return;
        }
        resetPassword({
            variables: {
                input: {
                    password: password,
                    passwordConfirmation: passwordConfirmation,
                    passwordResetToken: code
                }
            }
        });
    }
    (0, react_1.useEffect)(() => {
        if (data) {
            login({
                variables: {
                    input: {
                        email: data.performPasswordReset.user.email,
                        password: password
                    }
                }
            });
        }
        if (accountData) {
            setAccount(accountData.accounts.edges[0].node);
            // LocalAccount should no longer be necessary when we start using the
            // account context, but for now there's some duplication
            LocalAccount_1.default.set(accountData.accounts.edges[0].node);
            navigate('/orders', { replace: true });
        }
    }, [data, accountData]);
    let apiError = error;
    if (loginError) {
        apiError = loginError;
    }
    if (accountError) {
        apiError = accountError;
    }
    if (apiError) {
        apiError.title = passwordResetCopy_1.passwordResetCopy.errorTitle;
    }
    let apiLoading = false;
    if (loginLoading || accountLoading || loading) {
        apiLoading = true;
    }
    return (react_1.default.createElement(StyledImageBackground_1.StyledImageBackground, { id: 'login', url: blankBackground_webp_1.default },
        react_1.default.createElement(OnboardingForm_1.default, { apiError: apiError, contactLink: linkProps, cta: passwordResetCopy_1.passwordResetCopy.cta, header: passwordResetCopy_1.passwordResetCopy.header, inputs: [
                react_1.default.createElement(PasswordInput_1.default, { error: passwordError, id: 'password', key: 'password', label: passwordResetCopy_1.passwordResetCopy.input1, onBlur: handleBlur, onInputChange: handleInputChange }),
                react_1.default.createElement(PasswordInput_1.default, { error: passwordConfirmationError, id: 'passwordConfirmation', key: 'passwordConfirmation', label: passwordResetCopy_1.passwordResetCopy.input2, onBlur: handleBlur, onInputChange: handleInputChange }),
                react_1.default.createElement(components_1.TermsOfServiceCheckbox, { checked: serviceAgreement, error: agreementError, id: 'terms-of-service', key: 'terms-of-service', onChange: toggleServiceCheckbox })
            ], loading: apiLoading, onFormSubmit: handleReset, textPrompt: passwordResetCopy_1.passwordResetCopy.prompt }),
        react_1.default.createElement(HeroImage_1.default, { header: passwordResetCopy_1.passwordResetCopy.heroHeader, subheader: passwordResetCopy_1.passwordResetCopy.heroSubHeader })));
};
exports.default = PasswordReset;
